import React from 'react';
import styled from 'styled-components';
// @ts-ignore
import icon from './arrowright.svg';

type Props = {
  onClick?: () => void;
};
export default ({...props}: Props) => {
  return <Icon {...props} />;
};

const Icon = styled(icon)`
  width: 40px;
  height: 40px;
`;
